import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';
import SearchRetrieve from '../common/SearchRetrieve.new.js';

class AddReport extends Component {
    state = {
        saveParams: {},
        loading: false,
        visible: false,
    }

    show = () => {
        this.setState({ visible: true });
    }

    hide = () => {
        this.setState({
            visible: false,
            saveParams: {}
        });
    }

    save = () => {
        const { saveParams } = this.state;
        const { userId, leaderId } = saveParams;
        if (!userId) {
            message.error('请输入汇报者');
            return;
        }
        if (!leaderId) {
            message.error('请输入汇报对象');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.createVirtualReportLine,
            data: { ...saveParams },
            dataType: 'json',
            doneResult: data => {
                if (data.success) {
                    message.success(data.success);
                }
                this.setState({ loading: false }, () => {
                    this.hide();
                    this.props.loadData();
                });
            }, errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options)
    }

    handleChange = ({ value, text }, key) => {
        const { saveParams } = this.state;
        saveParams[`${key}Id`] = value;
        saveParams[`${key}Name`] = text;
        this.setState({ saveParams });
    }

    render() {
        const { visible, loading, saveParams } = this.state;
        const { userName, leaderName } = saveParams;
        return (
            <Modal
                title="添加汇报线"
                visible={visible}
                onCancel={this.hide}
                onOk={this.save}
                className="setjde-modal"
                maskClosable={false}
                width="400px"
            >
                <div className="cont-cont">
                    <Spin spinning={loading}>
                        <ul>
                            <li>
                                <div className="item">
                                    <label className="ui-label" style={{ width: "60px", display: "inline-block", marginLeft: "20px" }}>汇报者:</label>
                                    <span className="ui-text" >
                                        <SearchRetrieve
                                            keyword='keyword'
                                            style={{ width: 125 }}
                                            placeholder="请输入工号\姓名"
                                            value={userName}
                                            url={API_URL.team.userlist}
                                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                            onChange={value => this.handleChange(value, 'user')}
                                        />
                                    </span>
                                </div>
                            </li>
                            <li style={{ marginTop: "8px" }}>
                                <div className="item">
                                    <label className="ui-label" style={{ width: "60px", display: "inline-block", marginLeft: "20px" }}>汇报对象:</label>
                                    <span className="ui-text">
                                        <SearchRetrieve
                                            keyword='keyword'
                                            style={{ width: 125 }}
                                            placeholder="请输入工号\姓名"
                                            value={leaderName}
                                            url={API_URL.team.userlist}
                                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                            onChange={value => this.handleChange(value, 'leader')}
                                        />
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </Spin>
                </div>
            </Modal>
        );
    }
}

export default AddReport;



// WEBPACK FOOTER //
// ./src/components/user/AddReport.js